/**
 * 临时 API 封装：超时未跟进自动回公共池配置
 *
 * 后端 PR (wyr-system/wyr.crm.api 自动抓入公共池 issue #114) 合并后，
 * 请运行 `nad` 同步重新生成 `src/api.ts`，并把对应 systemController.*
 * 方法替换为生成出来的真实绑定，然后删除本文件。
 */
import { Runtime } from '../api';
import type { Settings } from '@huolala-tech/nad-runtime';

export interface QuickReturnPublicPoolConfig {
  /** 总开关 */
  enabled?: boolean;
  /** 分派来源 */
  fromAssign?: boolean;
  /** RMS 推送来源 */
  fromRmsPush?: boolean;
  /** 超时阈值（分钟） */
  minutes?: number;
}

export const quickReturnPublicPoolApi = {
  async get(settings?: Partial<Settings>) {
    return new Runtime<QuickReturnPublicPoolConfig>()
      .open('GET', '/system/quick_return_public_pool_config', settings)
      .execute();
  },
  async update(dto: QuickReturnPublicPoolConfig, settings?: Partial<Settings>) {
    return new Runtime<void>()
      .open('POST', '/system/quick_return_public_pool_config', settings)
      .addRequestBody(dto)
      .execute();
  },
};
